module.exports = {
  default: 'poppins',
  bold: 'poppins-bold',
};